// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"840426bb","656":"dc03130c","729":"639735e0","787":"feb633ff"}[chunkId] + ".chunk.js";
};